import { IRawData } from '../../Types/DoyPrediction';
import { IPrediction_v0 } from '../../Types/Predictions';
import { IRawEvent } from '../../Types/DoyPrediction';

export const translateRawData = (data: IPrediction_v0[]): (IRawEvent[]) => {
  const raw: (IRawEvent)[] = data.map(d => {
    var year = (new Date()).getFullYear().toString();
    if (d.bestcollection && d.bestcollection.length > 0) {
      year = (new Date(d.bestcollection[0].day)).getFullYear().toString() 
    } else if (d.bestdays && d.bestdays.length > 0) {
      year = (new Date(d.bestdays[0].day)).getFullYear().toString() 
    }
    
    if (d.rawdata !== null) {
      const x: IRawData = (d.rawdata as unknown) as IRawData;
      if (x.data) { 
        return {
          id: d.id,
          year: year,
          data: x.data
        } as IRawEvent; 
      }
    }

    return {
      id: d.id,
      year: year,
      data: []
    } as IRawEvent;
  });

  return raw;
}